import React from 'react';
import './css/network.css';
import { Link } from 'react-router-dom';

const Network = ({ numberPhone, combinedData }) => {
  return (
    <div className="fixed-right d-none d-md-block">
      {combinedData.map(
        (network, idx) =>
          network.icon && (
            <div key={idx} className={`item ${network.className}`}>
              <Link to={network.url} title={network.title} target="_blank">
                <img
                  src={network.icon}
                  alt={network.title}
                  className="mw-100"
                />
              </Link>
            </div>
          )
      )}
      <div className="item phone-ring">
        <a
          href={`tel:${numberPhone.value.replace(/[^0-9+]/g, '')}`}
          title={numberPhone.title}
        >
          <img
            src="/images/icons/phone-call-1-300x300.png"
            alt={numberPhone.title}
            className="mw-100"
          />
        </a>
      </div>
    </div>
  );
};

export default Network;
